import { FormHelperText, MenuItem } from '@mui/material';
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import ApiService, { userCode, username } from '../../../services/ApiService';
import ButtonService from '../ButtonService';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import CreateEditModalMaster from '../CreateEditModalMaster';
import { Input, Selection, showToast } from '../../../components/ui';

const CreateEditCountry = forwardRef((props, ref) => {
    const { isModal, handleClick, titleModal, title, param, selectedData, getData } = props

    const [isLoading, setIsLoading] = useState(true)
    const [continentList, setContinentList] = useState([])
    const [regionList, setRegionList] = useState([])

    useEffect(() => {
        if (isModal) {
            getAdditionalData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isModal])

    const errorToast = (location, closeModal = false) => {
        showToast({ type: 'error', message: `Can't get ${location} data! please contact Administrator` })
        if (closeModal) handleClick()
    }

    const getAdditionalData = async () => {
        try {
            const [resContinent, resRegion] = await Promise.all([
                ApiService.DynamicPostByPage('continent/continent', 'PAGE', 1, 9999, []),
                ApiService.DynamicPostByPage('region/region', 'PAGE', 1, 9999, [])
            ])

            if (resContinent.data.code === 200) {
                setContinentList(resContinent?.data?.data?.continent || [])
            } else {
                errorToast('continent', true)
            }

            if (resRegion.data.code === 200) {
                setRegionList(resRegion?.data?.data?.region || [])
            } else {
                errorToast('region', true)
            }
        } catch (error) {
            console.log(error)
            errorToast('additional', true)
        }

        setIsLoading(false)
    }

    const findContinent = (rId) => {
        if (!rId) return

        const region = regionList.find((reg) => reg.id === rId)
        formik.setFieldValue('continentId', region?.continentId)
    }

    const simpanLocal = () => {
        if (isModal) {
            const data = {
                "country": {
                    ...formik.values,
                    rowStatus: formik?.values?.rowStatus || 'ACT',
                    titleModal,
                    user: userCode,
                }
            }
            localStorage.setItem(username + "-Datacountry", JSON.stringify(data));
        }
    }

    useImperativeHandle(ref, () => ({

        localSave() {
            simpanLocal()
        }

    }));

    const validationSchema = Yup.object().shape({
        masterCode: Yup.string().nullable(),
        code: Yup.string().trim().required('This field is required.'),
        name: Yup.string().trim().required('This field is required.'),
        abbreviation: Yup.string().nullable(),
        regionId: Yup.number().required('This field is required.'),
        continentId: Yup.number().required('This field is required.'),
        currency: Yup.string().nullable(),
    })

    const formik = useFormik({
        initialValues: selectedData?.id ? {
            ...selectedData,
            regionId: selectedData?.regionId !== 0 ? selectedData.regionId : '',
            continentId: selectedData?.continentId !== 0 ? selectedData.continentId : '',
        } : {
            masterCode: '',
            code: '',
            name: '',
            abbreviation: '',
            regionId: '',
            continentId: '',
            currency: '',
        },
        validationSchema,
        onSubmit: (values) => Save(values)
    })

    const Save = (payload) => {
        if (payload?.name === '') {
            return showToast({ type: 'error', message: 'Country Name is Required!' });
        }

        if (payload?.regionId === '') {
            return showToast({ type: 'error', message: 'Region is Required!' });
        }

        if (payload?.abbreviation === '') {
            return showToast({ type: 'error', message: 'Abbreviation is Required!' });
        }

        if (payload?.currency === '') {
            return showToast({ type: 'error', message: 'Currency is Required!' });
        }

        const data = {
            "country": {
                "rowStatus": "ACT",
                "id": payload?.id,
                "code": payload?.code,
                "name": payload?.name,
                "abbreviation": payload?.abbreviation,
                "currency": payload?.currency,
                "continentId": payload?.continentId,
                "regionId": payload?.regionId,
                "masterCode": payload?.masterCode,
                "user": userCode
            }
        }

        ButtonService.Save(titleModal, title, param, data, () => {
            getData(1, 50, []);
            handleClick();
        });
    }

    const mainContainer = (
        <form onSubmit={formik.handleSubmit} style={{ marginTop: '12px' }}>
            <Input
                name="masterCode"
                label="Master Code"
                formControlProps={{
                    sx: {
                        width: '100%',
                        // marginTop: '16px'
                    }
                }}
                value={formik.values.masterCode}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('masterCode', e.target.value)}
                error={formik.touched.masterCode && Boolean(formik.errors.masterCode)}
                helperText={formik.touched.masterCode && formik.errors.masterCode}
                disabled
            />

            <Input
                name="code"
                label="Code"
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
                value={formik.values.code}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('code', e.target.value)}
                error={formik.touched.code && Boolean(formik.errors.code)}
                helperText={formik.touched.code && formik.errors.code}
            />

            <Selection
                id="continentId"
                label="Continent"
                name='continentId'
                labelId="lblContinent"
                placeholder={'Select Continent'}
                value={formik.values.continentId || ''}
                onChange={(e) => formik.setFieldValue('continentId', e.target.value)}
                error={formik.touched.continentId && Boolean(formik.errors.continentId)}
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
            >
                {
                    continentList.map((continent) => (
                        <MenuItem sx={{ fontSize: '12px' }} id={continent.id} key={continent.id} value={continent.id}>
                            {continent.name}
                        </MenuItem>
                    ))
                }
                <FormHelperText>{formik.touched.continentId && formik.errors.continentId}</FormHelperText>
            </Selection>

            <Selection
                id="region"
                label="Region"
                name='regionId'
                labelId="lblRegion"
                placeholder={'Select Region'}
                value={formik.values.regionId || ''}
                error={formik.touched.regionId && Boolean(formik.errors.regionId)}
                onChange={(e) => {
                    formik.setFieldValue('regionId', e.target.value)
                    findContinent(e.target.value)
                }}
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
            >
                {
                    regionList.map((region) => (
                        <MenuItem sx={{ fontSize: '12px' }} id={region.id} key={region.id} value={region.id}>
                            {region.name}
                        </MenuItem>
                    ))
                }
                <FormHelperText>{formik.touched.regionId && formik.errors.regionId}</FormHelperText>
            </Selection>

            <Input
                name="name"
                label="Country"
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
                value={formik.values.name}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('name', e.target.value)}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
            />

            <Input
                name="abbreviation"
                label="Abbreviation"
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
                value={formik.values.abbreviation}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('abbreviation', e.target.value)}
                error={formik.touched.abbreviation && Boolean(formik.errors.abbreviation)}
                helperText={formik.touched.abbreviation && formik.errors.abbreviation}
            />

            <Input
                name="currency"
                label="Currency"
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
                value={formik.values.currency}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('currency', e.target.value)}
                error={formik.touched.currency && Boolean(formik.errors.currency)}
                helperText={formik.touched.currency && formik.errors.currency}
            />
        </form>
    )

    return (
        <>
            {
                isModal && (
                    <CreateEditModalMaster
                        isModal={isModal}
                        titleModal={titleModal}
                        title={title}
                        isLoading={isLoading}
                        mainContainer={mainContainer}
                        handleClick={handleClick}
                        handleSave={() => Save(formik.values)}
                    />
                )
            }
        </>
    )
})

export default CreateEditCountry